'use client';
import React, { useState } from 'react';
import PropertyMapPanel from './PropertyMapPanel';
import ParcelRegistryTable from './ParcelRegistryTable';
import OwnershipChainPanel from './OwnershipChainPanel';
import AIDiscoveryPanel from './AIDiscoveryPanel';
import GISHubHeader from './GISHubHeader';
import PropertyValuationPanel from './PropertyValuationPanel';
import TaxBillGenerationPanel from './TaxBillGenerationPanel';
import DelinquencyTrackerPanel from './DelinquencyTrackerPanel';
import FieldInspectionPanel from './FieldInspectionPanel';
import EnforcementActionPanel from './EnforcementActionPanel';
import CountyPerformanceReportPanel from './CountyPerformanceReportPanel';
import UnregisteredPropertyPipelinePanel from './UnregisteredPropertyPipelinePanel';
import AddPropertyModal, { type NewParcel } from './AddPropertyModal';
import DroneIntegrationPanel from './DroneIntegrationPanel';

export type ActivePanel =
  | 'map' |'parcels' |'ownership' |'ai-discovery' |'valuation' |'tax-bills' |'delinquency' |'inspections' |'enforcement' |'performance' |'pipeline' |'drone';

export default function GISPropertyHubClient() {
  const [activePanel, setActivePanel] = useState<ActivePanel>('map');
  const [selectedParcelId, setSelectedParcelId] = useState<string | null>('LR-MON-0042');
  const [showAddProperty, setShowAddProperty] = useState(false);

  const handlePropertyAdded = (parcel: NewParcel) => {
    setSelectedParcelId(parcel.id);
    setActivePanel('parcels');
  };

  return (
    <div className="min-h-screen px-4 py-5 lg:px-6 xl:px-8 max-w-screen-2xl mx-auto">
      <GISHubHeader
        activePanel={activePanel}
        onPanelChange={setActivePanel}
        onAddProperty={() => setShowAddProperty(true)}
      />

      {activePanel === 'map' && (
        <PropertyMapPanel
          selectedParcelId={selectedParcelId}
          onSelectParcel={setSelectedParcelId}
        />
      )}
      {activePanel === 'parcels' && (
        <ParcelRegistryTable
          onSelectParcel={(id) => {
            setSelectedParcelId(id);
            setActivePanel('ownership');
          }}
        />
      )}
      {activePanel === 'ownership' && (
        <OwnershipChainPanel parcelId={selectedParcelId} />
      )}
      {activePanel === 'ai-discovery' && <AIDiscoveryPanel />}
      {activePanel === 'valuation' && <PropertyValuationPanel />}
      {activePanel === 'tax-bills' && <TaxBillGenerationPanel />}
      {activePanel === 'delinquency' && <DelinquencyTrackerPanel />}
      {activePanel === 'inspections' && <FieldInspectionPanel />}
      {activePanel === 'enforcement' && <EnforcementActionPanel />}
      {activePanel === 'performance' && <CountyPerformanceReportPanel />}
      {activePanel === 'pipeline' && <UnregisteredPropertyPipelinePanel />}
      {activePanel === 'drone' && <DroneIntegrationPanel />}

      {showAddProperty && (
        <AddPropertyModal
          onClose={() => setShowAddProperty(false)}
          onSuccess={handlePropertyAdded}
        />
      )}
    </div>
  );
}
